module.exports = __webpack_public_path__ + "img/fstpic.989e3aaf.png";